export default __webpack_public_path__ + "static/media/livingroom.d63a8fb9.jpeg";